






























































import Vue from 'vue'
import SimpleInput from '@/UI/Shared/SimpleInput.vue'
import ParishSelector from '@/UI/Auction/PersonalData/Fields/ParishSelector.vue'
import ProvinceSelector from '@/UI/Auction/PersonalData/Fields/ProvinceSelector.vue'
import CountySelector from '@/UI/Auction/PersonalData/Fields/CountySelector.vue'
import PlaceSelector from '@/UI/Auction/PersonalData/Fields/PlaceSelector.vue'
import PostalCodeField from '@/UI/Auction/PersonalData/Fields/PostalCodeField.vue'

export default Vue.extend({
  name: 'LocationForm',
  components: {
    SimpleInput,
    ParishSelector,
    PlaceSelector,
    ProvinceSelector,
    CountySelector,
    PostalCodeField
  },
  props: {
    province: {
      type: String,
      default: ''
    },
    county: {
      type: String,
      default: ''
    },
    parish: {
      type: String,
      default: ''
    },
    postalCode: {
      type: String,
      default: ''
    },
    place: {
      type: String,
      default: ''
    },
    local: {
      type: String,
      default: ''
    },
    formDisabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    countyDisabled (): boolean {
      return this.formDisabled || !this.localProvince
    },
    validCounty (): boolean {
      return !this.countyDisabled && this.countiesLoaded > 0 && this.localCounty !== ''
    },
    parishDisabled (): boolean {
      return this.formDisabled || !this.localCounty
    },
    postalCodeDisabled (): boolean {
      return this.formDisabled || !this.validCounty
    },
    placeDisabled (): boolean {
      return this.formDisabled || !this.localPostalCode
    },
    localDisabled (): boolean {
      return this.formDisabled || !this.localPostalCode
    },
    selectorLocalProvinceStatus (): string {
      if (this.localProvince !== '') {
        return 'required ok'
      }
      return 'required'
    },
    selectorLocalCountyStatus (): string {
      if (this.localCounty !== '') {
        return 'required ok'
      }
      return 'required'
    },
    selectorLocalParishStatus (): string {
      if (this.localParish !== '') {
        return 'ok'
      }
      return ''
    },
    selectorLocalPlaceStatus (): string {
      if (this.localPlace !== '') {
        return 'ok'
      }
      return ''
    }
  },
  data () {
    return {
      countiesLoaded: 0,
      localProvince: '',
      localCounty: '',
      localPlace: '',
      localPostalCode: '',
      localParish: '',
      localLocal: '',
      localProvinceNome: '',
      localCountyNome: '',
      localPlaceNome: '',
      localParishNome: ''
    }
  },
  watch: {
    province (newValue) {
      this.localProvince = newValue
    },
    county (newValue) {
      this.localCounty = newValue
    },
    parish (newValue) {
      this.localParish = newValue
    },
    postalCode (newValue) {
      this.localPostalCode = newValue
    },
    local (newValue) {
      this.localLocal = newValue
    },
    place (newValue) {
      this.localPlace = newValue
    }
  },
  created () {
    this.localProvince = this.province
    this.localCounty = this.county
    this.localParish = this.parish
    this.localPostalCode = this.postalCode
    this.localLocal = this.local
    this.localPlace = this.place
  },
  methods: {
    sendUpdatedData (): void {
      this.$emit('property-updated', {
        parish: this.localParish,
        parishName: this.localParishNome,
        place: this.localPlace,
        placeName: this.localPlaceNome,
        postalCode: this.localPostalCode,
        province: this.localProvince,
        provinceName: this.localProvinceNome,
        county: this.localCounty,
        countyName: this.localCountyNome,
        local: this.localLocal
      })
    }
  }
})
